/*--------------------------------------------------------------------------*
 * チェックボックス
 *--------------------------------------------------------------------------*/
module Module_Checkbox {
	export class Model_Checkbox {
		// チェック数のカウント
		countChecks(inputs: JQuery): number {
			var counter: number = 0;
			inputs.each(function(): void {
				if($(this).prop("checked")) counter++;
			});
			return counter;
		}

		// 子チェックのプロパティを変更
		changeChildProp(elm: JQuery): void {
			const chldCheck: JQuery = elm.parents(".c-parent_check").next(".c-searchbox__checkbox").find('[data-check="child"]').not('[data-check="child"]:disabled');
			chldCheck.prop("checked", elm.prop("checked"));
		}

		// 親チェックのプロパティを変更
		changePrntProp(elm: JQuery): void {
			const checkbox: Model_Checkbox = new Model_Checkbox(),
				chldChecks: JQuery    = elm.parents(".c-searchbox__checkbox").find('[data-check="child"]').not('[data-check="child"]:disabled'),
				prntCheck: JQuery     = elm.parents(".c-searchbox__checkbox").prev(".c-parent_check").find('[data-check="parent"]'),
				checkCount: number = checkbox.countChecks(chldChecks);
			prntCheck.prop("checked", checkCount === chldChecks.length);
		}
	}
}
